import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface BackdropProps {
  ref: any;
  hide?: boolean;
}

interface FixedContainerProps {
  $backgroundColor?: string;
}

interface DesktopContainerProps {
  width?: number;
  $backgroundColor?: string;
}

export const Transition = styled(ReactCSSTransitionGroup)`
  /* Modal fade */
  .fade-enter {
    opacity: 0%;
  }

  .fade-enter.fade-enter-active {
    opacity: 100%;
    transition: opacity 0.3s;
  }

  .fade-leave {
    opacity: 100%;
  }

  .fade-leave.fade-leave-active {
    opacity: 0%;
    transition: opacity 0.3s;
  }

  /* Sidebar */
  .right-fade-enter {
    opacity: 0%;

    & > div {
      right: -100%;
    }
  }

  .right-fade-enter.right-fade-enter-active {
    opacity: 100%;
    transition: opacity 0.5s ease-in-out;

    & > div {
      right: 0;
      transition: right 0.5s ease-in-out;
    }
  }

  .right-fade-leave {
    opacity: 100%;

    & > div {
      right: 0;
    }
  }

  .right-fade-leave.right-fade-leave-active {
    opacity: 0%;
    transition: opacity 0.5s ease-in-out;

    & > div {
      right: -100%;
      transition: right 1s ease-in-out;
    }
  }
`;

export const Backdrop = styled.div<BackdropProps>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;

  width: 100%;
  height: 100%;

  background: ${({ hide }) => (hide ? ColorPalette.Transparent : `rgba(${ColorPalette.RGB.Black}, 50%)`)};
`;

export const Modal = styled.div<DesktopContainerProps>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;

  background: ${({ $backgroundColor }) => $backgroundColor || ColorPalette.HEX.White};
  width: ${({ width }) => width || 500}px;
  min-height: 200px;
  padding: ${({ $backgroundColor }) => ($backgroundColor !== undefined ? '0' : '20px 10px 20px 20px')};
  border-radius: 20px;
  box-shadow: 0 2px 8px 0 rgba(${ColorPalette.RGB.Black}, 0.2);
`;

export const ModalContent = styled.div`
  max-height: min(800px, 90vh);

  overflow-y: auto;
  padding-right: 10px;

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 3px rgba(${ColorPalette.RGB.Black}, 0.3);
    border-radius: 5px;
    background-color: ${ColorPalette.HEX.Cultured3};
  }

  &::-webkit-scrollbar {
    width: 6px;
    background-color: ${ColorPalette.HEX.Cultured3};
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    box-shadow: inset 0 0 3px rgba(${ColorPalette.RGB.Black}, 0.3);
    background-color: ${ColorPalette.HEX.DavysGrey2};
  }
`;

export const Sidebar = styled.div<DesktopContainerProps>`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 20;

  background: ${({ $backgroundColor }) => $backgroundColor || ColorPalette.HEX.White};
  width: ${({ width }) => width || 500}px;
  height: 100%;
  padding: 20px 10px 20px 20px;
  box-shadow: 0 2px 8px 0 rgba(${ColorPalette.RGB.Black}, 0.2);
`;

export const SidebarContent = styled.div`
  height: 100%;

  overflow-y: auto;
  padding-right: 10px;

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 3px rgba(${ColorPalette.RGB.Black}, 0.3);
    border-radius: 5px;
    background-color: ${ColorPalette.HEX.Cultured3};
  }

  &::-webkit-scrollbar {
    width: 6px;
    background-color: ${ColorPalette.HEX.Cultured3};
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    box-shadow: inset 0 0 3px rgba(${ColorPalette.RGB.Black}, 0.3);
    background-color: ${ColorPalette.HEX.DavysGrey2};
  }
`;

export const FixedContainer = styled.div<FixedContainerProps>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  background: ${({ $backgroundColor }) => $backgroundColor || ColorPalette.HEX.White};
  z-index: 2;
`;
